/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { chatShowMessage } from '../../axios/chatShowMessage'
import type {
	ChatShowMessageError,
	ChatShowMessagePathParams,
	ChatShowMessageResponse,
} from '../../types/ChatShowMessage'

export const chatShowMessageQueryKey = (
	chat: ChatShowMessagePathParams['chat'],
	providerMessageId: ChatShowMessagePathParams['providerMessageId'],
) => [{ url: '/chat/:chat/messages/:providerMessageId', params: { chat, providerMessageId } }] as const

export type ChatShowMessageQueryKey = ReturnType<typeof chatShowMessageQueryKey>

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::showMessage */
export function chatShowMessageQueryOptions(
	chat: ChatShowMessagePathParams['chat'],
	providerMessageId: ChatShowMessagePathParams['providerMessageId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		ChatShowMessageResponse,
		AxiosError<ChatShowMessageError>,
		ChatShowMessageResponse,
		ChatShowMessageQueryKey
	>({
		queryKey: chatShowMessageQueryKey(chat, providerMessageId),
		queryFn: ({ signal }) => chatShowMessage(chat, providerMessageId, { signal, ...config }).then(res => res.data),
		enabled: !!(chat && providerMessageId),
	})
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::showMessage */
export function useChatShowMessage<TSelectData = ChatShowMessageResponse>(
	chat: ChatShowMessagePathParams['chat'],
	providerMessageId: ChatShowMessagePathParams['providerMessageId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					ChatShowMessageResponse,
					AxiosError<ChatShowMessageError>,
					TSelectData,
					ChatShowMessageQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ChatShowMessageError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...chatShowMessageQueryOptions(chat, providerMessageId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::showMessage */
export function useChatShowMessageSuspense<TSelectData = ChatShowMessageResponse>(
	chat: ChatShowMessagePathParams['chat'],
	providerMessageId: ChatShowMessagePathParams['providerMessageId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					ChatShowMessageResponse,
					AxiosError<ChatShowMessageError>,
					TSelectData,
					ChatShowMessageQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ChatShowMessageError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...chatShowMessageQueryOptions(chat, providerMessageId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
